import { inject, Component, effect, signal } from '@angular/core';
import { AlertStore, IAlertItem } from '@alert/data-access';
import { ToastComponent } from './alert-box/toast.component';
import { animate, style, transition, trigger } from '@angular/animations';
import { UiStore } from '@theme/data-access';
import { NgClass } from '@angular/common';

@Component({
  selector: 'lib-alert',
  templateUrl: './alert.component.html',
  imports: [ToastComponent, NgClass],
  animations: [
    [
      trigger('slideX', [
        transition(':enter', [
          style({ transform: 'translateY(100%)', opacity: 0 }),
          animate(
            '200ms ease',
            style({ transform: 'translateX(0)', opacity: 1 })
          ),
        ]),
        transition(':leave', [
          animate(
            '200ms ease',
            style({ transform: 'translateX(100%)', opacity: 0 })
          ),
        ]),
      ]),
    ],
  ],
})
export class AlertComponent {
  public readonly alertStore = inject(AlertStore);
  public readonly uiStore = inject(UiStore);
  public alertList = signal<IAlertItem[]>([]);


  constructor() {
    effect(() => {
      this.alertList.set(
        this.alertStore
          .alertListEntities());
    });
  }

  removeAlert(alertItem: IAlertItem): void {
    this.alertStore.removeAlert(alertItem.id);
  }

}
